"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _endpoints = require("../endpoints");
var _promiseCache = _interopRequireDefault(require("../utils/promise-cache"));
var _fetchWithAuth = _interopRequireDefault(require("../utils/fetch-with-auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function SolutionService(authState) {
  const fetch = new _fetchWithAuth.default(authState);
  const cache = new _promiseCache.default(authState);
  async function listSolutions() {
    return await cache('listSolutions', async () => {
      const res = await fetch(`${_endpoints.solutionURL}/solutions`, {
        headers: {
          'content-type': 'application/json'
        }
      });
      const json = await res.json();
      return json;
    })();
  }
  const getSolution = async solutionId => {
    const {
      solutions
    } = await listSolutions();
    if (Array.isArray(solutions)) {
      if (solutionId) {
        return solutions.find(s => s.id === solutionId);
      }
      // if no solutionId was passed in, return the first solution
      return solutions[0];
    }
  };
  return {
    listSolutions,
    getSolution
  };
}
var _default = exports.default = SolutionService;
//# sourceMappingURL=solution.js.map